module.exports = __webpack_public_path__ + "static/img/privilege-bg01.a7f279a.png";